<template>
    <van-popup
            v-if="selectStockPopupShow" v-model="selectStockPopupShow" :close-on-click-overlay="false" @click-overlay="handleClickClose"
            :style="{ height: '450px', }"overlay-class="custom_popup"position="bottom" round>

        <div class="select_stock_wrap" >
            <div class="select_stock_search">
                <van-search v-model="keyword" @input="fuzzySearch" placeholder="请输入仓库名称" />
            </div>
            <div class="select_stock_content">
                <van-picker :loading="loading"  :columns="warehouseList" :default-index="defaultIndex" :visible-item-count="7"  ref="popupPicker" swipe-duration="100"  title=""   value-key="name"  />
            </div>
            <div class="select_stock_footer">
                <van-button round block type="info" @click="handleClickConfirm">确定</van-button>
            </div>
        </div>
    </van-popup>

</template>

<script>
import { stockList } from "@/api";
export default {
    name: "select_stock",
    props: {
        selectStockPopupShow: {
            type: Boolean,
            default: false,
        },
        selectedStockId: {
            type: Number,
            default: 0,
        },
        disabledStockId: {
            type: Number,
            default: 0,
        },//禁止
        stockList: {
            type: Array,
            default: ()=>[],
        },
        allAuthority: {
            type: Boolean,
            default: false,
        }, //是否全部仓库权限
    },
    data() {
        return {
            loading: false,
            keyword:'',
            warehouseList:[],
            allWarehouseList:[],
            defaultIndex:0
        };
    },
    created() {

        if(this.stockList && this.stockList.length>0){
            this.warehouseList = this.stockList
        }else{
            this.getStockList()
        }

    },
    methods: {
        // 获取仓库列表
        getStockList(){
            this.loading = true
            stockList({}).then(res => {
                if (res.code === 200) {
                    res.data.forEach((item)=>{
                        if(item.id == this.disabledStockId){
                            this.$set(item,'disabled',true)
                        }
                    })
                    this.warehouseList = res.data
                    this.allWarehouseList =  JSON.parse(JSON.stringify(res.data))
                    this.defaultIndex = this.allWarehouseList.findIndex(item => item.id == this.selectedStockId)
                    this.loading = false
                }
            })
        },
        fuzzySearch() {
            this.warehouseList = this.allWarehouseList.filter(item => item.name.includes(this.keyword));
        },

        handleClickClose(){
            this.$emit("update:selectStockPopupShow", false)
        },

        handleClickConfirm(){
            let value = this.$refs.popupPicker.getValues()[0]

            if(value){
                this.$emit("success", value)
                this.$emit("update:selectStockPopupShow", false)
            }else{
                this.$toast("请选择仓库")
            }


        },
    },
}
</script>

<style  lang="scss" scoped>
.custom_popup {
    background-color: rgba(0, 0, 0, 0.3);
}
.select_stock_wrap{
    display: flex;
    flex-direction: column;
    height: 100%;
    .select_stock_search{
        padding: 2px 4px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    }
    .select_stock_content{
        flex: 1;
    }
    .select_stock_footer {
        padding:16px;
        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}

</style>